var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": _vm.width },
      model: {
        value: _vm.modal_informativo,
        callback: function($$v) {
          _vm.modal_informativo = $$v
        },
        expression: "modal_informativo"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v(_vm._s(_vm.titulo) + "\n      ")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c("v-card-text", [_vm._t("default")], 2),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", depressed: "", small: "", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeModal(false)
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "#526da5" } }, [
                    _vm._v(_vm._s(_vm.textoBtnNo))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }